import { PELGO_SITE_URL, toAbsoluteUrl } from '@/lib/pelgo-seo'
import type { Whitepaper } from '@/lib/whitepapers'
import { getWhitepaperLandingPath } from '@/lib/whitepapers'

type WhitepaperJsonLdProps = {
  whitepaper: Whitepaper
}

export function WhitepaperJsonLd({ whitepaper }: WhitepaperJsonLdProps) {
  const canonicalPath = getWhitepaperLandingPath(whitepaper.slug)

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Report',
    name: whitepaper.title,
    description: whitepaper.shortDescription,
    datePublished: whitepaper.publishedAt,
    image: toAbsoluteUrl(whitepaper.coverImageSrc),
    url: toAbsoluteUrl(canonicalPath),
    publisher: {
      '@type': 'Organization',
      name: 'Pelgo',
      url: PELGO_SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: toAbsoluteUrl('/logo-black.png'),
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': toAbsoluteUrl(canonicalPath),
    },
  }

  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD requires inline script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}
